<div
    class="ce-cookie-banner fx-column fx-flex"
    *ngIf="isUserAuthed() && readConsentChoice() === undefined && gaDomain !== ''"
>
    <ng-container *ngIf="readConsentChoice() === undefined && gaDomain !== ''">
        <h1><strong>This service uses cookies</strong></h1>
        <br />
        <p>We use cookies and store data such as IP addresses for two purposes.</p>
        <br />
        <h2><strong>Essential cookies</strong></h2>
        <p>Essential cookies are necessary for this web service to work properly. These cookies are always active.</p>
        <br />
        <h2><strong>Analytics cookies</strong></h2>
        <p>
            Analytics cookies are used to collect usage analytics data. We use this data to understand how the service
            is used and to improve your experience with it.
        </p>
        <br />
        <p>
            You can <strong>accept all cookies</strong> or <strong>accept essential cookies only</strong> and later
            change your choice in the profile section of your ChargEye account.
        </p>
        <br />
        <div class="cookie-buttons">
            <div class="cookie-buttons">
                <div class="accept">
                    <button (click)="updateConsentChoice(true)" (keydown.enter)="updateConsentChoice(true)">
                        Accept all
                    </button>
                </div>
                <div class="decline">
                    <button (click)="updateConsentChoice(false)" (keydown.enter)="updateConsentChoice(false)">
                        Accept essential only
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
